export default (feeds, getId) => {
  const structure = {};
  Object.entries(feeds)
    .forEach(([key, naming]) => {
      structure[key] = data => naming(getId(data));
    });
  return structure;
};



// WEBPACK FOOTER //
// ./~/virgo/src/structures/feedsToStructure.js